
<!-- Top Bar Start -->
<div class="topbar">

    <!-- LOGO -->
    <div class="topbar-left">
        <a [routerLink]="['/dashboard']" class="logo">
            <span>
                <img src="./assets/images/logo-sm.png" alt="logo-small" class="logo-sm">
            </span>
            <span>
                <img src="./assets/images/logo.png" alt="logo-large" class="logo-lg">
                <img src="./assets/images/logo-dark.png" alt="logo-large" class="logo-lg logo-dark">
            </span>
        </a>
    </div>
    <!--end logo-->
    <!-- Navbar -->
    <nav class="navbar-custom">
        <ul *ngIf="isLoggedIn$ | async as currentUser" class="list-unstyled topbar-nav float-right mb-0">
            <li class="dropdown notification-list">
                <a (click)="onNotificationDropdownClick($event)" class="nav-link dropdown-toggle arrow-none waves-light waves-effect" href="#" role="button"
                    aria-haspopup="false" aria-expanded="false">
                    <fa-icon [icon]="faBell"></fa-icon>
                    <p-badge [value]="notificationsCount" styleClass="noti-icon-badge" [severity]="(notifications.length ? 'danger' : 'success')"></p-badge>
                </a>
                <div class="dropdown-menu dropdown-menu-right dropdown-lg" [ngClass]="notificationDropdownIsOpened ? 'show': ''">
                    <!-- item-->
                    <h6 class="dropdown-item-text"><span i18n>Notifications</span> ({{notificationsCount}})</h6>
                    <div class="notification-list">
                        <p-scrollPanel *ngIf="notifications?.length; else notificationsEmpty" [style]="{width: '100%', 'height': '300px'}">
                            <a *ngFor="let notification of notifications" [routerLink]="notification.path" class="dropdown-item notify-item">
                                <div class="notify-icon" [ngClass]="'severity-' + notification.severity"><fa-icon [icon]="iconStringToIcon(notification.icon)"></fa-icon></div>
                                <p class="notify-details">{{notification.name}}<small class="text-muted">{{notification.description}}</small></p>
                            </a>
                        </p-scrollPanel>
                    </div><!--active-->
                    <!--a href="#" class="dropdown-item text-center text-primary">
                        View all <i class="fi-arrow-right"></i>
                    </a-->
                </div>
            </li>

            <li class="dropdown" [ngClass]="userDropdownIsOpened ? 'show': ''">
                <a (click)="onUserDropdownClick($event)" class="nav-link dropdown-toggle waves-effect waves-light nav-user" href="#" role="button"
                    aria-haspopup="false" aria-expanded="false">
                    <img *ngIf="currentUser.user.emailHash" class="rounded-circle" [alt]="currentUser.user.fullName" src="{{currentUser.user.emailHash|gravatar}}">
                    <span class="ml-1 nav-user-name hidden-sm">{{currentUser.user.fullName}} <i class="mdi mdi-chevron-down"></i> </span>
                </a>
                <div class="dropdown-menu dropdown-menu-right" [ngClass]="userDropdownIsOpened ? 'show': ''">
                    <a class="dropdown-item" [routerLink]="['/settings/account']"><fa-icon [icon]="faUser"></fa-icon>&nbsp;<span i18n>Profile settings</span></a>
                    <div class="dropdown-divider"></div>
                    <a class="dropdown-item" href="#" (click)="handleLogOut($event)"><fa-icon [icon]="faSignOutAlt"></fa-icon>&nbsp;<span i18n>Log out</span></a>
                </div>
            </li>
        </ul><!--end topbar-nav-->

        <ul class="list-unstyled topbar-nav mb-0">
            <li>
                <button class="button-menu-mobile nav-link waves-effect waves-light" (click)="onMenuToggleClick()">
                    <fa-icon [icon]="faBars"></fa-icon>
                </button>
            </li>
        </ul>
    </nav>
    <!-- end navbar-->
</div>
<!-- Top Bar End -->
<ng-template #notificationsEmpty>
    <span class="dropdown-item notify-item">
        <div class="notify-icon" [ngClass]="'severity-success'"><fa-icon [icon]="faSmileWink"></fa-icon></div>
        <p class="notify-details"> <span i18n>All caught up!</span><small class="text-muted" i18n>Take a break, do what you do best.</small></p>
    </span>
</ng-template>